import React from "react";
import { HashLink as Link } from "react-router-hash-link";
import logo from "./../../assets/images/logo2.svg";

const Footer = () => {
  return (
    <section className="Footer-section">
      <section className="Footer-container">
        <img src={logo} alt="logo" />
        <ul className="Footer-nav">
          <ul className="Footer-navlist">
            <Link to="#acceuil">Accueil</Link>
            <Link to="#services">Services</Link>
            <Link to="#about">À propos</Link>
            <Link to="#contact">Contact</Link>
          </ul>
          <ul className="Footer-infolist">
            <a href="https://maps.app.goo.gl/YSFfXiehojSnP5da7" target="_blank" rel="noreferrer">
              14 avenue Georges Clémenceau, 06000 NICE
            </a>
            <a href="tel:+33668318132" target="_blank" rel="noreferrer">
              T / +33 (0)6 68 31 81 32
            </a>
            <a href="mailto:contact@jppcompta.fr" target="_blank" rel="noreferrer">
              E / contact@jppcompta.fr
            </a>
          </ul>
        </ul>
      </section>
      <section className="Footer-container2">
      <p>
  &#xA9;&nbsp;Copyright&nbsp;{new Date().getFullYear()}&nbsp;Designed with 💜 by{" "}
  <a className="whiteLink" href="https://maelcorp.com/">MaelCorp</a>.
</p>
        <Link to="/mention-legal" className="whiteLink">
          Mentions légales • Politique de confidentialité • Politique de cookies
        </Link>
      </section>
    </section>
  );
};

export default Footer;